import { render, staticRenderFns } from "./ProdutosDetalhe.vue?vue&type=template&id=4f16eeea"
import script from "./ProdutosDetalhe.vue?vue&type=script&lang=js"
export * from "./ProdutosDetalhe.vue?vue&type=script&lang=js"
import style0 from "./ProdutosDetalhe.vue?vue&type=style&index=0&id=4f16eeea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports